const MenuTwoLineIcon = /*#__PURE__*/ [
  ["path", { d: "M4 9L20 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 15L14 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { MenuTwoLineIcon as default };
//# sourceMappingURL=MenuTwoLineIcon.js.map
